import axios from "axios";
import { translateError, currentLang } from "@/lib/errors";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  config.headers["X-Lang"] = currentLang();
  return config;
});

export function formatApiErrorDetail(detail) {
  return translateError(rawDetail(detail), currentLang());
}

function rawDetail(detail) {
  if (detail == null) return "Noe gikk galt. Prøv igjen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const GUEST_KEY = "guest_token";
export const guestHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem(GUEST_KEY)}` });

export function toTakkState(r) {
  return {
    code: r.code,
    fornavn: r.fornavn,
    alreadyRegistered: r.already_registered,
    codeBrukt: r.code_brukt,
    aktivert: r.code_brukt_tidspunkt,
    innlost: r.innlost,
    gyldigFra: r.gyldig_fra,
    utloper: r.utloper,
  };
}
